/**
 * The signature element of the landing page: a working miniature of the real
 * attract screen, glowing inside the calm business page.
 *
 * An owner's whole decision is "what will my TV look like?", so the hero
 * answers it literally rather than with a screenshot. Pure CSS animation —
 * no JS timers, so it costs nothing on the one page that must stay light.
 */
export function MockTv() {
  return (
    <div className="lf-tv" aria-label="A preview of the LobbyFun screen in a waiting room">
      <div className="lf-tv__bezel">
        <div className="lf-tv__screen">
          {/* Three cards cross-fade on the same 12s cycle the real TV uses. */}
          <div className="lf-tv__card lf-tv__card--1">
            <span className="lf-tv__title">BRICK BLAST</span>
            <span className="lf-tv__accent">Today&apos;s record: 18,420</span>
            <span className="lf-tv__muted">Can you beat it while you wait?</span>
          </div>

          <div className="lf-tv__card lf-tv__card--2">
            <span className="lf-tv__accent">🏆 CURRENT LOBBY BOSS</span>
            <span className="lf-tv__title lf-tv__title--sm">MIKE — 18,420</span>
            <span className="lf-tv__muted">Think you can take the crown?</span>
          </div>

          <div className="lf-tv__card lf-tv__card--3">
            <span className="lf-tv__title lf-tv__title--sm">$20 off wheel alignment today</span>
            <span className="lf-tv__muted">— Manchester Auto</span>
          </div>

          {/* The QR never moves, exactly as on the real screen. */}
          <div className="lf-tv__qr" aria-hidden>
            <span className="lf-tv__qr-pattern" />
            <span className="lf-tv__qr-label">SCAN TO PLAY</span>
          </div>
        </div>
      </div>
      <span className="lf-tv__stand" aria-hidden />
    </div>
  );
}
